import { periodOptions } from '@pages/CalculatorPage/helpers';
import { config } from '@utils/config';

export const OtherIncomeQuestions = {
  maintenanceIncome: {
    getFieldName: (applicantNumber: any) => {
      return `applicants[${applicantNumber}].otherIncome.maintenanceIncome`;
    },
    titleKey: 'affordabilityCalculator.otherIncome.maintenanceIncome.title',
    textKey: 'affordabilityCalculator.otherIncome.maintenanceIncome.text',
    periodOptions,
  },
  pensionIncome: {
    getFieldName: (applicantNumber: any) => {
      return `applicants[${applicantNumber}].otherIncome.pensionIncome`;
    },
    titleKey: 'affordabilityCalculator.otherIncome.pensionIncome.title',
    textKey: 'affordabilityCalculator.otherIncome.pensionIncome.text',
    textHref: config.env.VITE_INTERMEDIARIES_URL,
    periodOptions,
  },
  rentalIncome: {
    getFieldName: (applicantNumber: any) => {
      return `applicants[${applicantNumber}].otherIncome.rentalIncome`;
    },
    titleKey: 'affordabilityCalculator.otherIncome.rentalIncome.title',
    textKey: 'affordabilityCalculator.otherIncome.rentalIncome.text',
    periodOptions,
  },
  error: {
    required: 'common.error.requiredField',
  },
};
